import { render, staticRenderFns } from "./TwitterAuth.vue?vue&type=template&id=672380f8&scoped=true"
import script from "./TwitterAuth.vue?vue&type=script&lang=js"
export * from "./TwitterAuth.vue?vue&type=script&lang=js"
import style0 from "./TwitterAuth.vue?vue&type=style&index=0&id=672380f8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672380f8",
  null
  
)

export default component.exports